export const test_subdomain: string = 'test'
export const subdomain: string = 'scandibet'
const prefix = 'https://'
const Server = 'gamingenius.net'
const server = getServer(Server)
export const prefixWallet = 'ext-wallet'
export const prefixAdminServer = 'as'
export const namespace = 'promotions'
export const prefixPromostore = 'promostore'

const promostoreServer: string = prefix + prefixPromostore + '.' + server
// const promostoreServer: string = 'http://localhost:5544'

export const promostoreLanguage: string = promostoreServer + '/language-part/'
export const promostoreServerSublevels: string = promostoreServer + '/sublevels/'
export const promostoreServerLevels: string = promostoreServer + '/levels/'
export const promostoreServerRegistration: string = promostoreServer + '/registration/'
export const promostoreServerLogin: string = promostoreServer + '/login/'
export const promostoreServerLogout: string = promostoreServer + '/logout/'
export const promostoreServerShopItems: string = promostoreServer + '/shop-items/'
export const promostorePlayerStatsXPlXP: string = promostoreServer + '/player-stats-xpl-xp/'
export const promostoreServerRst: string = promostoreServer + '/rst/'
export const promostoreServerRstc: string = promostoreServer + '/rstc/'
export const promostoreServerAllPlayerRST: string = promostoreServer + '/all-player-rst/'
// export const promostoreServerRstb: string = promostoreServer + '/rstb/'
// export const promostoreServerRstbc: string = promostoreServer + '/rstbc/'
export const promostoreServerRsta: string = promostoreServer + '/rsta/'
export const promostoreServerPlayerPointsXp: string = promostoreServer + '/player-points-xp/'
export const promostoreServerPointsXp: string = promostoreServer + '/points-xp/'
export const promostoreServerDecodeJWT: string = promostoreServer + '/decode-jwt/'

/* wallet */
// export const walletServerAuthorize: string = walletServer + '/authorize'
// export const walletServerPlayer: string = walletServer + '/player'
// export const walletServerBalance: string = walletServer + '/balance'

/* admin server*/
const adminServer: string = prefix + prefixAdminServer + '.' + server
export const adminServerImages: string = adminServer + '/images/'
export const adminServerTestSiteData: string = adminServer + '/test-site-data/'
export const adminServerUserData: string = adminServer + '/user-data/'
export const adminServerLogo: string = adminServer + '/logo/'

function getServer(SERVER: string): string {
    const host: string = window.location.host
    // x.gamanza.com
    if (host.startsWith('localhost')) return SERVER
    return host.substring(host.indexOf('.') + 1, host.length)
}


// WEBPACK FOOTER //
// ./src/Logic/Config.ts